// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Round);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-icon-dd0Ta {
  --size: 24px;
  display: block;
  width: var(--size);
  height: var(--size);
  font-size: var(--size);
  cursor: pointer;
  overflow: hidden;
  user-select: none;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/icon/icon.module.css"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["@import url('https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Round');\n\n.icon {\n  --size: 24px;\n  display: block;\n  width: var(--size);\n  height: var(--size);\n  font-size: var(--size);\n  cursor: pointer;\n  overflow: hidden;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `icon-icon-dd0Ta`
};
export default ___CSS_LOADER_EXPORT___;
